import { defineMessages } from "react-intl";

export const columnMessages = defineMessages({
  collection: {
    id: '88YDUH',
    defaultMessage: "Kit",
    description: "kit list column",
  },
  discount: {
    id: 'cD+mYs',
    defaultMessage: "Discount",
    description: "kit list column",
  },
  freightClass: {
    id: 'P82c4R',
    defaultMessage: "Freight class",
    description: "kit list column",
  },
  status: {
    id: '5t/IcY',
    defaultMessage: "Status",
    description: "kit list column",
  },
});

export const messages = defineMessages({
  createKit: {
    id: 'icOSa7',
    defaultMessage: "Create kit",
    description: "kit list, button",
  },
  noKits: {
    id: '7vimUL',
    defaultMessage: "No kits found",
    description: "kit list, empty state",
  },
  searchPlaceholder: {
    id: 'NV4b1C',
    defaultMessage: "Search kits",
    description: "kit list, search field",
  },
});
